'use client';

import { Box, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const ErrorBoundaryFallback = () => {
  const { t } = useTranslation();
  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') {
      const timer = setTimeout(() => {
        window.location.replace('/home');
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <Box role="alert">
      <Typography variant="body2">
        {t('something_went_wrong_redirect_to_menu')}
      </Typography>
    </Box>
  );
};
